import useWindowSize from "../../../../../hooks/useWindowSize";
import { useFormActaStore } from "../../../../../store/formActaStore";

const DatosPersonalesGeneral = () => {
  const size = useWindowSize();
  const { width } = size;
  const { defaultValues } = useFormActaStore();

  return (
    <>
      {/* <section className={` ${width >= 640 ? "col-6" : "col-12"} d-flex flex-column gap-4`}> */}
      <section
        style={{ fontSize: "14px" }}
        className={`d-flex ${width >= 640 ? "col-12   " : "col-12 flex-column gap-4"} gap-1`}
      >
        <div className={`${width < 640 ? "col-12" : "col"}`}>
          <h5 className="text-dark">Datos personles</h5>
          <p className="m-0 text-primary fw-bold">
            Nombre: <span className="fw-medium text-dark">{defaultValues?.nombre_ciudadano}</span>
          </p>
          {/* <div className="d-flex gap-2 flex-wrap"> */}
          <p className="m-0 text-primary fw-bold">
            Documento: <span className="fw-medium text-dark">{defaultValues?.dni}</span>
          </p>
          <p className="m-0 text-primary fw-bold">
            Teléfono: <span className="fw-medium text-dark">{defaultValues?.telefono}</span>
          </p>
          {/* </div> */}
          <p className="m-0 text-primary fw-bold">
            Email: <span className="fw-medium text-dark">{defaultValues?.email}</span>
          </p>
          <p className="m-0 text-primary fw-bold">
            Barrio: <span className="fw-medium text-dark">{defaultValues?.barrio}</span>
          </p>
          {defaultValues.sector && (
            <p className="m-0 text-primary fw-bold">
              Sector: <span className="fw-medium text-dark">{defaultValues?.sector}</span>
            </p>
          )}
          <p className="m-0 text-primary fw-bold">
            Domicilio: <span className="fw-medium text-dark">{defaultValues?.domicilio}</span>
          </p>
          {/* <div className="d-flex gap-2 flex-wrap"> */}
          {/* <p className="m-0 text-primary fw-bold">
            Barrio:{" "}
            <span className="fw-medium text-dark">
              {defaultValues?.barrio_original?.descripcion}
            </span>
          </p> */}

          {/* </div> */}
        </div>
        {/* <div className="col"> */}
        <div className={`${width < 640 ? "col-12" : "col"}`}>
          <h5 className="text-dark">Datos de la solicitud</h5>
          {/* <div className="d-flex gap-2 flex-wrap"> */}
          <div className="d-flex gap-2">
            <p className="m-0 text-primary fw-bold">Lugar: </p>
            <span className="fw-medium text-dark">{defaultValues?.lugar}</span>
          </div>
          <div className="d-flex gap-2">
            <p className="m-0 text-primary fw-bold">Tipo solicitante: </p>
            <span className="fw-medium text-dark">{defaultValues?.tipo_persona_solicitante}</span>
          </div>
          <div className="d-flex gap-2">
            <p className="m-0 text-primary fw-bold" style={{ wordBreak: "break-word" }}>
              Solicitante:{" "}
            </p>
            <span className="fw-medium text-dark" style={{ wordBreak: "break-word" }}>
              {defaultValues?.solicitante}
            </span>
          </div>
          <div className="d-flex gap-2">
            <p className="m-0 text-primary fw-bold">Descripción: </p>
            <span className="fw-medium text-dark">{defaultValues?.descripcion}</span>
          </div>
          <div className="d-flex flex-column ">
            <p className="m-0 text-primary fw-bold">Tipo de solicitud: </p>
            <ul>
              {defaultValues?.tipos_solicitud.map((solicitud, index) => {
                return (
                  <li key={index}>
                    {`${solicitud.nombre} | cant. arboles: ${solicitud.cantidad_arboles}`}{" "}
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </section>
    </>
  );
};
export default DatosPersonalesGeneral;
